/* src/app/components/modals/new-version-available/new-version-available.component.scss */
.overlay.nsm-overlay-open {
  background: rgba(3, 14, 86, 0.8) !important;
}
.overlay.nsm-overlay-open .nsm-content {
  background-color: transparent !important;
  box-shadow: none;
  padding: 0 !important;
}
.overlay.nsm-overlay-open .nsm-content .nsm-dialog-btn-close {
  display: none !important;
}
@keyframes modal-fade-in {
  from {
    opacity: 0;
    transform: translateY(0.75rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
::ng-deep .nsm-dialog {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
}
::ng-deep .nsm-dialog.add-in {
  min-width: 1rem !important;
}
::ng-deep .nsm-dialog.add-in .modal {
  width: 65% !important;
  margin-left: auto;
  margin-right: auto;
}
::ng-deep .nsm-dialog.wide,
::ng-deep .nsm-dialog.wider,
::ng-deep .nsm-dialog.wider-plus,
::ng-deep .nsm-dialog.widest,
::ng-deep .nsm-dialog.import-viewer-modal {
  min-width: 64rem;
}
::ng-deep .nsm-dialog.nsm-centered {
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep .nsm-dialog.nsm-centered > .nsm-content {
  margin: auto;
  width: fit-content;
  max-width: calc(100vw - 3.5rem);
}
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.modal {
  position: relative;
  width: 32rem;
  height: auto;
  animation: modal-fade-in 350ms cubic-bezier(0, 0.6, 0.4, 1) both;
  background: #FFFFFF;
  box-shadow: 0rem 0.5rem 1.25rem rgba(0, 0, 0, 0.13), 0rem 0.9375rem 1.875rem rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;
  padding-bottom: 2rem;
  overflow-wrap: break-word;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 92.5vh;
}
.modal .modal-header .modal-title {
  overflow-y: hidden;
}
.modal .modal-header .modal-close {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow-y: hidden;
}
.modal.wide {
  width: 50rem !important;
}
.modal.wide .modal-header .modal-close {
  flex: 1 1 0;
  text-align: right;
}
.modal.wider {
  width: 55rem !important;
}
.modal.wider .modal-header .modal-close {
  flex: 1 1 0;
  text-align: right;
}
.modal.wider-plus {
  width: 60rem !important;
}
.modal.wider-plus .modal-header .modal-close {
  flex: 1 1 0;
  text-align: right;
}
.modal.widest {
  width: 80vw !important;
}
.modal.widest .modal-header .modal-close {
  flex: 1 1 0;
  text-align: right;
}
.modal .modal-header {
  width: calc(100% - 5rem);
  height: 1.875rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 2rem 2.5rem;
}
.modal .modal-header .modal-title {
  font-family: "PoppinsExtra Bold";
  font-size: 1.5rem;
  line-height: 1.875rem;
  width: 25.5rem;
}
.modal .modal-header .modal-title.success {
  color: #108467;
}
.modal .modal-header .modal-title.warning {
  color: #D1691F;
}
.modal .modal-header .modal-title.danger {
  color: #DB2121;
}
.modal .modal-header .modal-close {
  height: 1.875rem;
  width: 3.5rem;
  margin-right: -0.5rem;
  position: relative;
  z-index: 5000;
  top: 0;
}
.modal .modal-header .modal-close svg-icon {
  width: 2.975rem;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
.modal .modal-header .modal-close svg-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.modal .modal-header .modal-close:hover {
  cursor: pointer;
}
.modal .modal-body {
  padding: 0.5rem 2.5rem 0 2.5rem;
}
.modal .modal-body ul {
  list-style: none;
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
  margin-left: -0.5rem;
  width: calc(100% + 0.5rem);
}
.modal .modal-body ul li {
  list-style: none none;
  margin-bottom: 0.5rem;
  background-color: #fff;
  padding: 0.25rem 0.5rem;
  transition: background 300ms ease-in-out;
  display: flex;
  align-items: center;
}
.modal .modal-body ul li:hover {
  cursor: pointer;
  background-color: #E6EAFF;
  border-radius: 0.25rem;
}
.modal .modal-body ul li.active {
  background-color: #E6EAFF;
  border-radius: 0.25rem;
}
.modal .modal-body .modal-text {
  display: block;
}
.modal .modal-body .modal-text strong {
  font-family: "PoppinsExtra Bold" !important;
}
.modal .modal-body .modal-tag-preview {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 100%;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col {
  display: inline-flex;
  align-items: center;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col .tag-table-content-col-color {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col .tag-table-content-col-color ::ng-deep svg-icon svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col .tag-table-content-col-text {
  min-width: 0;
  font-family: "PoppinsSemi Bold";
  font-size: 0.934375rem;
  line-height: 1.4375rem;
  color: #15141E;
  word-break: break-word;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col:nth-child(1) {
  flex: 0 0 auto;
}
.modal .modal-body .modal-tag-preview .tag-table-content-row .tag-table-content-col:nth-child(2) {
  flex: 1;
  min-width: 0;
}
.modal .modal-body .modal-button.cancel button {
  margin-right: 1rem !important;
}
.modal .modal-body .modal-button.success {
  background-color: #108467;
}
.modal .modal-body .modal-button.warning {
  background-color: #D1691F;
}
.modal .modal-body .modal-button.danger {
  background-color: #DB2121;
}
.modal .modal-body .modal-button.info {
  background-color: #AAAAAA;
}
.modal .modal-body .modal-button.primary {
  background-color: #1E31BF;
}
.modal .modal-body .modal-button.success {
  background-color: #108467;
}
@media (prefers-reduced-motion: reduce) {
  .modal {
    animation: none;
  }
}
@media (prefers-color-scheme: dark) {
  .modal.dark-mode p.add-ref-link {
    color: white !important;
  }
  .modal.dark-mode label {
    color: white !important;
  }
  .modal.dark-mode .related-content-form-container {
    background-color: #15161c !important;
  }
  .modal.dark-mode {
    background-color: #2B2B2B !important;
  }
  .modal.dark-mode .modal-body .modal-text {
    color: white !important;
  }
  .modal.dark-mode .modal-title {
    color: white !important;
  }
  .modal.dark-mode .modal-header .modal-close svg-icon.iconRight svg path {
    fill: white !important;
    color: white !important;
  }
  .modal.dark-mode .modal-close ::ng-deep app-centrui-icon svg-icon svg path {
    fill: white !important;
    color: white !important;
  }
}
.related-content-form-container {
  width: 100%;
  position: relative;
}
.related-content-form-container label {
  width: calc(100% - 2.2rem);
  padding: 1rem 2.2rem 0 2.2rem;
  font-family: "PoppinsExtra Bold";
  font-size: 1.125rem;
  line-height: 1.75rem;
  color: #15141E;
  letter-spacing: -0.01875rem;
}
.related-content-form-container input[type=file] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}
.related-content-form-container .resource-file-dummy {
  padding: 1.875rem;
  background-color: rgba(30, 49, 191, 0.04) !important;
  border: 0.125rem dashed #1E31BF;
  border-radius: 0.25rem;
  text-align: center;
  transition: background 0.3s ease-in-out;
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  line-height: 1rem;
  color: #1E31BF;
  margin: 0 0 2rem 0;
}
.related-content-form-container .resource-file-dummy .success {
  display: none;
}
.related-content-form-container:hover .resource-file-dummy {
  background: rgba(255, 255, 255, 0.1);
}
.related-content-form-container input[type=file]:focus + .resource-file-dummy {
  outline: #1E31BF auto 0.3125rem;
}
.related-content-form-container input[type=file]:valid + .resource-file-dummy {
  border-color: rgba(30, 49, 191, 0.48) !important;
  background-color: rgba(30, 49, 191, 0.16) !important;
}
.related-content-form-container input[type=file]:valid + .resource-file-dummy .success {
  display: inline-block;
}
.related-content-form-container input[type=file]:valid + .resource-file-dummy .default {
  display: none;
}
.modal-body {
  position: relative;
}
.modal-body .info-message {
  font-family: "PoppinsRegular";
  font-size: 1rem;
  font-style: normal;
  line-height: 1.5rem;
  color: #000000;
  margin-bottom: 2rem;
  max-height: 36rem;
  height: auto;
  overflow: auto;
}
/*# sourceMappingURL=new-version-available.component.css.map */
